<template>
  <div>
    <h3 style="text-align: center;"><b>
      Salary and allowances statistic
      <!-- THỐNG KÊ LƯƠNG VÀ CÁC KHOẢN PHỤ CẤP -->
    </b></h3>

    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template #cell(STT)="data">
        {{ data.index + 1 }}
      </template>
      <!-- <template v-slot:cell(ngaysinh)="data">{{formatDate(data.value)}}</template> -->
      <!-- <template v-slot:cell(ngaythuviec)="data">{{formatDate(data.value)}}</template> -->
      <!-- <template v-slot:cell(ngaychinhthuc)="data">{{formatDate(data.value)}}</template> -->
      <template #cell(luongcoban)="data">
        <div v-if="data.item.luongcoban!=0 && data.item.luongcoban!=null ">
          <strong> {{data.item.luongcoban | numeral('0,0')}} </strong>
        </div>
      </template>

      <template #cell(phucap_xangxe)="data">
        <div v-if="data.item.phucap_xangxe!=0 && data.item.phucap_xangxe!=null ">
          {{data.item.phucap_xangxe | numeral('0,0')}}
        </div>
      </template>
      <template #cell(phucap_dienthoai)="data">
        <div v-if="data.item.phucap_dienthoai!=0 && data.item.phucap_dienthoai!=null ">
          {{data.item.phucap_dienthoai | numeral('0,0')}}
        </div>
      </template>
      <template #cell(phucap_nhao)="data">
        <div v-if="data.item.phucap_nhao!=0 && data.item.phucap_nhao!=null ">
          {{data.item.phucap_nhao | numeral('0,0')}}
        </div>
      </template>
      <template #cell(phucap_trangphuc)="data">
        <div v-if="data.item.phucap_trangphuc!=0 && data.item.phucap_trangphuc!=null ">
          {{data.item.phucap_trangphuc | numeral('0,0')}}
        </div>
      </template>
      <template #cell(phucap_nuoicon)="data">
        <div v-if="data.item.phucap_nuoicon!=0 && data.item.phucap_nuoicon!=null ">
          {{data.item.phucap_nuoicon | numeral('0,0')}}
        </div>
      </template>
      <template #cell(phucap_tong)="data">
        <div v-if="data.item.phucap_tong!=0 && data.item.phucap_tong!=null ">
          <strong> {{data.item.phucap_tong | numeral('0,0')}} </strong>
        </div>
      </template>
      <template #cell(tongluong)="data">
        <strong>
          {{(data.item.phucap_tong + data.item.luongcoban )| numeral('0,0')}}
        </strong>
      </template>
    </b-table>
    <b-badge variant="light">
      Sum: {{ totalRow }}
      <!-- Tổng số: {{ totalRow }} -->
    </b-badge>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report11",
  //props: ["vitricongviecs", "loaihopdongs", "departments"],
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "No.",
          // label: "STT",
          thClass: "align-middle",
          thStyle: {width: "15px", textAlign : "center"},
        }, //STT Vitural
        {
          key: "manhanvien",
          label: "Code",
          // label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "70px", textAlign : "center"},
        },
        {
          key: "hovaten",
          label: "Name",
          // label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        // {
        //   key: "gioitinh",
        //   label: "Giới tính",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "ngaysinh",
        //   label: "Ngày sinh",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Vị trí công việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
         {
          key: "donvicongtacshort",
          label: "COM",
          // label: "Đơn vị công tác",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {width: "100px", textAlign : "center"},
        },
        // {
        //   key: "ngaythuviec",
        //   label: "Ngày thử việc",
        //   sortable: true,
        // },
        // {
        //   key: "ngaychinhthuc",
        //   label: "Ngày chính thức",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        // {
        //   key: "loaihopdong",
        //   label: "Loại hợp đồng",
        //   sortable: true,
        //   thClass: "align-middle",
        //   thStyle: {textAlign : "center"},
        // },
        {
          key: "luongcoban",
          label: "Basic salary",
          // label: "Lương cơ bản",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_xangxe",
          label: "Gas allowance",
          // label: "P/C xăng xe",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_dienthoai",
          label: "Mobile phone allowance",
          // label: "P/C điện thoại",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_nhao",
          label: "House rental allowance",
          // label: "P/C nhà ở",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_trangphuc",
          label: "Travel allowance", //Update 20241018: Thay đổi thứ tự phụ cấp, thay thế phụ cấp (Trang phục (Clothing) -> Đi lại (Travel))
          // label: "P/C trang phục",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_nuoicon",
          label: "Child-care allowances",
          // label: "P/C nuôi con",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "phucap_tong",
          label: "Total allowances",
          // label: "Tổng P/C",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "tongluong",
          label: "Total salary",
          // label: "Tổng lương",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        // {
        //   key: "email",
        //   label: "Email",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "tinhtranghoso",
        //   label: "Tình trạng",
        //   sortable: true,
        //   thClass: "text-center",
        // },
      ],
      items: [],
      totalRow: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 11;
      axios
        .get(`/api/employeereport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
    paginationChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
